<div class="ver-archivo">
  <h2 class="card-title">{{ title }}</h2>
  <hr>
  <div class="card-icon">
    <mat-icon>gavel</mat-icon>
  </div>
  <div class="line"> </div>  
    <p class="negrita">Autor: <span>{{document.author || 'Sin autor'}}</span></p>
    <p class="negrita">Función: <span>{{document.author_function || 'Sin función'}}</span></p>
    <p class="negrita">Fecha: <span>{{ document.publication_date ? (document.publication_date | date: 'dd/MM/yyyy HH:mm') : 'Sin Fecha'}}</span></p>
    <button class="btn-view" (click)='viewFile()'>Ver Archivo</button>
</div>
